import { CarouselNavigation } from "theme";

class InfiniteCarouselNavigation extends CarouselNavigation {
  connectedCallback() {
    super.connectedCallback();
    this.originalElementsAmount = this.carousel.querySelectorAll("div:not([data-clone])").length;
  }

  onButtonClicked(newIndex) {
    this.carousel.select(newIndex);
  }

  onNavigationChange(index) {
    const newIndex =
      index < this.originalElementsAmount ? index : index % this.originalElementsAmount;
    super.onNavigationChange(newIndex);
  }
}

window.customElements.define("infinite-carousel-navigation", InfiniteCarouselNavigation);
